<template>
  <div>
    <pin-list ref="pinList" :data-func="loadPins" />
  </div>
</template>

<script>
  import pinList from '../../../common/pin-list.vue';

  import state from '../../../../state';
  import pinService from '../../../../services/pin.service';
  import currencyService from '../../../../services/currency.service';

  import { required, minValue } from 'vuelidate/lib/validators';

  export default {
    name: 'player-pins',
    components: { pinList },
    data() {
      return {
        newPin: {
          value: 0,
          currency: null,
          branch: null,
          description: null
        }
      }
    },
    computed: {
      playerId() {
        return this.$route.params.playerId;
      },
      player() {
        return state.editPlayer.get();
      },
      currencies() {
        return state.currencies.get();
      }
    },
    validations: {
      newPin: {
        value: {
          required,
          minValue: minValue(0.01)
        },
        currency: {
          required
        }
      }
    },
    async mounted() {
      await this.$refs.pinList.load();
    },
    methods: {
      async loadPins(filter) {
        return await pinService.getByPlayer(this.playerId, filter);
      },
      async create() {
        await pinService.create(this.playerId, this.getSourcePinValue(), this.newPin.currency, this.newPin.branch, this.newPin.description, this.newPin.isDemo);
        await this.$refs.pinList.load();
      },
      getSourcePinValue() {
        return currencyService.toSource(this.newPin.value, this.newPin.currency);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/players/player/pins.vue